import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { noop } from 'lodash';
import withHighlightColumnHandler from '../../../../hoc/withHighlightColumnHandler';
import styles from './MatrixCell.scss';

class MatrixCell extends PureComponent {
  static propTypes = {
    cellRenderer: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    className: PropTypes.string,
    contentClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    style: PropTypes.object,
    errorColored: PropTypes.bool,
    isTransparent: PropTypes.bool,
    hasBottomLightBorder: PropTypes.bool,
    hasInput: PropTypes.bool,
    hasBottomSolidBorder: PropTypes.bool,
    hasTopSolidBorder: PropTypes.bool,
    colSpan: PropTypes.number,
    highlightParentColumn: PropTypes.func,
    styleCellRenderer: PropTypes.object,
    unhighlightParentColumn: PropTypes.func,
  };

  static defaultProps = {
    onMouseEnter: noop,
    onClick: noop,
    onMouseLeave: noop,
    highlightAppropriateColumn: noop,
    styleCellRenderer: {},
    unHighlightAppropriateColumn: noop,
  };

  handleMouseEnter = (...args) => {
    this.props.onMouseEnter(...args);
    this.props.highlightParentColumn();
  };

  handleMouseLeave = (...args) => {
    this.props.onMouseLeave(...args);
    this.props.unhighlightParentColumn();
  };

  render() {
    const {
      cellRenderer: CellRenderer,
      className,
      contentClassName,
      style,
      isTransparent,
      hasInput,
      colSpan,
      hasBottomLightBorder,
      errorColored,
      hasTopSolidBorder,
      hasBottomSolidBorder,
      styleCellRenderer,
      ...rest
    } = this.props;

    return (
      <td
        colSpan={colSpan}
        data-e2e="matrix-cell"
        style={style}
        className={cx(className, {
          [styles.cellItem]: true,
          [styles.input]: hasInput,
          [styles.transparent]: isTransparent,
          [styles.error]: errorColored,
          [styles.bottomLightBorder]: hasBottomLightBorder,
          [styles.bottomSolidBorder]: hasBottomSolidBorder,
          [styles.topSolidBorder]: hasTopSolidBorder,
        })}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        data-testid="SurveysSpa-MatrixTable-MatrixCell"
      >
        {CellRenderer && (
          <CellRenderer
            className={cx(contentClassName, styles.cellInner)}
            style={styleCellRenderer}
            {...rest}
          />
        )}
      </td>
    );
  }
}

export default withHighlightColumnHandler(MatrixCell);
